import './subscription-block.component.css'
import { loadStripe } from '@stripe/stripe-js'
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from '@stripe/react-stripe-js'
import { useEffect, useState } from 'react'
import API from '../../../api'
import { Portal } from 'react-portal'
import { closeIcon } from '../../icons'

const stripePromise = loadStripe(
  'pk_test_51OKPJYBh21YCs9613kwajGQfWANO1m8KIh4VLOgLynBJnmeICxiouoK4wyHMdJFzpBQ4wl9gEN7zsk61EcLKKU8F003931kIor',
  {},
)

const PRICES = {
  two: 'price_1Q8uajBh21YCs961YwHTNanE',
  three: 'price_1Q8ub5Bh21YCs961hGKGqJAa',
}

const SubscriptionBlockComponent = () => {
  const [showModal, setShowModal] = useState()
  const [clientSecret, setClientSecret] = useState()
  const [success, setSuccess] = useState()

  useEffect(() => {
    const handleSubscribe = async (e) => {
      try {
        const { detail } = e
        const price = PRICES[detail?.price] || PRICES.two
        const returnUrl = `${window.location.href}?return=true`
        const res = await API.postContent('checkout', {
          returnUrl,
          price,
        })

        setClientSecret(res?.client_secret)
        setShowModal(true)
      } catch (e) {
        // todo handle error
      }
    }

    const getSessionStatus = async (sid) => {
      try {
        const res = await API.postContent('checkout/session', {
          sessionId: sid,
        })

        console.log(res)
        setSuccess(res)
      } catch (e) {
        // todo handle error
      }
    }

    const urlParams = new URLSearchParams(window.location.search)
    const sessionId = urlParams.get('session_id')
    if (sessionId) {
      getSessionStatus(sessionId)
    }

    // Listen for action
    document.addEventListener('EVENTS.SUBSCRIBE', handleSubscribe)
    return () =>
      document.removeEventListener('EVENTS.SUBSCRIBE', handleSubscribe)
  }, [])

  return (
    <>
      {showModal && clientSecret && (
        <Portal>
          <div
            className="prg-subscription-modal"
            onClick={() => setShowModal(false)}
          >
            <div
              className="prg-subscription-modal-container"
              onClick={(e) => e.stopPropagation()}
            >
              <EmbeddedCheckoutProvider
                stripe={stripePromise}
                options={{ clientSecret }}
              >
                <EmbeddedCheckout />
              </EmbeddedCheckoutProvider>
            </div>
          </div>
        </Portal>
      )}
      {success && (
        <Portal>
          <div
            className="prg-subscription-modal"
            onClick={() => setSuccess(false)}
          >
            <div
              className="prg-subscription-modal-container prg-subscription-result"
              onClick={(e) => e.stopPropagation()}
            >
              <button onClick={() => setSuccess(false)}>{closeIcon}</button>
              <h3>Welcome to the club, {success.customerName}!</h3>
              <h4>
                This is confirmation of your subscription to LUCA's wine club.
              </h4>
              <p>
                To check or modify your subscription, please take note of the
                email address you booked with,{' '}
                <strong>{success.customerEmail}</strong> and visit{' '}
                <strong>https://eatluca.com/luca-wine-subscription</strong>
              </p>
              <p>Thanks, we hope to see you in LUCA soon!</p>
            </div>
          </div>
        </Portal>
      )}
    </>
  )
}

export default SubscriptionBlockComponent
